import { useNavigate } from 'react-router-dom';
import AppRoutes from 'constants/AppRoutes';
import { MATERIAL_ASSESSMENT_STAKEHOLDERS_LIST } from 'constants/materialAssessment';
import { useGetMaterialityStakeholdersQuery } from 'store/slices/materialAssessment/apis/materialAssessmentApi';

const useNavigateStakeholders = (recordId: string, vcmId: number) => {
  const navigate = useNavigate();
  const {
    data,
  } = useGetMaterialityStakeholdersQuery({ maId: recordId, vcmId }, {
    refetchOnMountOrArgChange: true,
    skip: vcmId === null,
  });

  const list = data?.data.items || [];

  const findNextActive = (selectedStakeholder: number) => MATERIAL_ASSESSMENT_STAKEHOLDERS_LIST
    .slice(selectedStakeholder + 1)
    .find((stakeholder) => {
      const isActiveStakeholder = list.find(
        (item) => item.type === stakeholder.value && item.isActive === true,
      );
      return isActiveStakeholder?.isActive;
    })?.value;

  const navigateToStakeholder = (stakeholderId: string) => {
    const selectedStakeholder = MATERIAL_ASSESSMENT_STAKEHOLDERS_LIST.findIndex((item) => item.value === stakeholderId);
    const findNext = findNextActive(selectedStakeholder);

    if (findNext && Object.keys(findNext).length > 0) {
      navigate(`${AppRoutes.materialityAssessmentStakeholdersDefault
        .replace(':recordId', recordId)
        .replace(':stakeholderId', findNext)}/${vcmId}`);
    } else {
      navigate(AppRoutes.materialityAssessmentStakeholders.replace(':recordId', recordId));
    }
  };

  return {
    navigateToStakeholder,
  };
};
export default useNavigateStakeholders;
